import z from 'zod'

export const verifyOtpFormSchema = z.object({
  otp: z.string().min(6),
})
